import AppDialog, { DialogProps } from 'qcc/AppDialog'
import { AppPopover,PopoverProps } from 'qcc/AppPopover'
import { locationHistory } from 'services/history'
import { DrawerProps } from 'antd/lib/drawer'
import AppDrawer from '../AppDrawer'
import { message } from 'antd'
import AppMessage from '../AppMessage'
import AppFullMaskLayer from '../AppFullMaskLayer'

export const AppAction = {
	open: (url: string) => {
		window.open(url)
	},
	openDialog: (component?: React.ReactElement, props?: DialogProps,render?:JSX.Element | string) => {
		AppDialog.open(component, props,render)
	},
	closeDialog: () => {
		AppDialog.close()
	},
	openPop : ( component: React.ReactElement,
		props?:PopoverProps,
		target?:any,
		render?:JSX.Element | string) =>{
		AppPopover.open(component,props,target,render);
	},
	coverFull:()=>{
		AppFullMaskLayer.open();
	},
	cancelCoverFull:()=>{
		AppFullMaskLayer.close();
	},
	closePop:() =>{
		AppPopover.close();
	},
	redirect: (url: string) => {
		locationHistory.get().push(url)
	},
	openDrawer: (component: React.ReactElement, drawerProps?: DrawerProps) => {
		AppDrawer.show(component, drawerProps)
	},
	closeDrawer: () => {
		AppDrawer.hide()
	},
	alert: async (msg: string) => {
		return await AppMessage.alark(msg)
	},
	confirm: async (msg: string) => {
		return await AppMessage.confirm(msg)
	},
	deleteConfirm: async (msg: string) => {
		return await AppMessage.confirm(msg, true)
	},
	successMsg: (msg: string) => {
		message.success(msg)
	},
	warnMsg: (msg: string) => {
		message.warn(msg)
	},
	errorMsg: (msg: string) => {
		message.error(msg)
	},
}





// WEBPACK FOOTER //
// ./src/qcc/AppAction/index.ts